import { FC } from 'react'
import { useRequest } from 'ahooks'

import { toast } from '$app/utilities'

import useReturnTo from '$actions/useReturnTo'

import { AnonymousAuthAPI } from '$api/anonymous-auth'

import ResetPasswordForm, {
  ResetPasswordFormProps
} from '$hook-forms/ResetPasswordForm'

import { container, header, title } from './styles.css'

const { resetPassword, errorMessageResolver } = new AnonymousAuthAPI(null)

export const ResetPasswordBlock: FC<{
  email: string
  token: string
}> = ({ email, token }) => {
  const redirect = useReturnTo()

  const { loading, runAsync } = useRequest(resetPassword, { manual: true })

  const onSuccess: ResetPasswordFormProps['onSuccess'] = async (
    reset,
    { password }
  ) => {
    await toast
      .promise(runAsync({ email, token, password }), {
        loading: 'Resetting..',
        error: errorMessageResolver,
        success: 'Success! Please login using your new password.',
        duration: 5000
      })
      .unwrap()

    reset()

    redirect('authLogin')
  }

  return (
    <section className={container}>
      <header className={header}>
        <h2 className={title}>Reset your password</h2>
      </header>

      <ResetPasswordForm onSuccess={onSuccess} disabled={loading} />
    </section>
  )
}

export default ResetPasswordBlock
